/** @format */

import {styled} from '@mui/material/styles';
import {Typography} from '@mui/material';

export const Text = styled(Typography)(() => ({
  textAlign: 'right',
}));
